module.exports = __webpack_public_path__ + "band_8_daughter.f74b572f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_8_daughter.png
// module id = L0LT
// module chunks = 0